module.exports = __webpack_public_path__ + "img/b510d5d.webp";